// password_toggle.ts - Handle password toggle button clicks

import { on } from 'delegated-events'

on('click', '.js-password-toggle', function (event: Event): void {
  event.preventDefault()

  const button = event.currentTarget as HTMLButtonElement | null
  if (!button) return

  const container = button.closest('.js-password-container')
  if (!container) return

  const input = container.querySelector<HTMLInputElement>('.js-password-input')
  if (!input) return

  // Toggle input type
  const isPassword = input.type === 'password'
  input.type = isPassword ? 'text' : 'password'

  // Toggle icons
  const eyeIcon = container.querySelector('.js-show-icon')
  const eyeOffIcon = container.querySelector('.js-hide-icon')

  if (eyeIcon && eyeOffIcon) {
    eyeIcon.classList.toggle('hidden')
    eyeOffIcon.classList.toggle('hidden')
  }

  // Update aria-label
  button.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password')
})
